import { Flex, Image, Menu } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { navMenuItems as menuItems } from "functions/navFuncs";
import seeAiLogoShort from "assets/seeai-logo-short-dark-mode.png";
import seeAiLogoLong from "assets/seeai-logo-long-dark-mode.png";

const SideMenuBar = ({ collapsed }) => {
  const navigate = useNavigate();
  const { pathname: currentNavPath } = useLocation();

  const seeAiLogo = collapsed ? seeAiLogoShort : seeAiLogoLong;

  return (
    <>
      <Flex vertical={true} gap="small">
        <Flex justify="center">
          <Link to={"/home"}>
            <Image
              preview={false}
              height={60}
              src={seeAiLogo}
              style={{
                padding: "1rem",
              }}
            />
          </Link>
        </Flex>
        <Menu
          items={menuItems}
          selectedKeys={[currentNavPath]}
          defaultOpenKeys={["Items"]}
          onClick={(menuItem) => {
            navigate(menuItem.key);
          }}
          mode="inline"
        />
      </Flex>
    </>
  );
};

export default SideMenuBar;
